module.exports = __webpack_public_path__ + "static/img/pic_08@2x.f6c6e364.png";